import React from "react";
import languageStorage from "../lang/findLanguage";

export default function FooterMenu({ language }) {
  return (
    <div className="footer-menu">
      <div className="container d-flex align-items-center justify-content-between">
        <a href="https://app.bandwitt.com/" target="_blank" rel="noreferrer">
          {languageStorage() === "tr" ? language[0].sections[9].keys[0].k0001 : language[1].sections[9].keys[0].k0001}
        </a>
        <a href={`#${languageStorage() === "tr" ? language[0].sections[11].keys[0].k0001 : language[1].sections[11].keys[0].k0001}`}>
          {languageStorage() === "tr" ? language[0].sections[9].keys[1].k0002 : language[1].sections[9].keys[1].k0002}
        </a>
        <a href={`#${languageStorage() === "tr" ? language[0].sections[11].keys[1].k0002 : language[1].sections[11].keys[1].k0002}`}>
          {languageStorage() === "tr" ? language[0].sections[9].keys[2].k0003 : language[1].sections[9].keys[2].k0003}
        </a>
        <a href={`#${languageStorage() === "tr" ? language[0].sections[11].keys[2].k0003 : language[1].sections[11].keys[2].k0003}`}>
          {languageStorage() === "tr" ? language[0].sections[9].keys[3].k0004 : language[1].sections[9].keys[3].k0004}
        </a>
        <a href={`#${languageStorage() === "tr" ? language[0].sections[11].keys[3].k0004 : language[1].sections[11].keys[3].k0004}`}>
          {languageStorage() === "tr" ? language[0].sections[9].keys[4].k0005 : language[1].sections[9].keys[4].k0005}
        </a>
        <a href={`#${languageStorage() === "tr" ? language[0].sections[11].keys[4].k0005 : language[1].sections[11].keys[4].k0005}`}>
          {languageStorage() === "tr" ? language[0].sections[9].keys[5].k0006 : language[1].sections[9].keys[5].k0006}
        </a>
        <a href={`#${languageStorage() === "tr" ? language[0].sections[11].keys[5].k0006 : language[1].sections[11].keys[5].k0006}`}>
          {languageStorage() === "tr" ? language[0].sections[9].keys[6].k0007 : language[1].sections[9].keys[6].k0007}
        </a>
      </div>
    </div>
  );
}
